/**
 * @file 选择质押币种弹窗
 */
import { useState } from 'react';
import { Modal, Input } from '@bfe/moly';
import { ShareIcon } from '@bfe/moly-icons';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useCoinInfoContext } from '@/hooks/useCoinInfo';
import { chainNameByChainCodeMap } from '@/config/map';
import { shortAddress } from '@/utils/common';
import BigNumber from 'bignumber.js';
import { ethAddress, etherscanHostByCode } from '@/config/address';
import { useFm } from '@web3/base-hooks';
import { Loading } from '@/components';
import { useCoinPrice } from './hooks';

import styles from './index.module.scss';

interface Props {
  onSelectCoin: (key: string, balance: string) => void;
  onClose: () => void;
}

export const SelectCoinModal = (props: Props) => {
  const fm = useFm();
  const { onSelectCoin, onClose } = props;
  const { poolInfo } = usePoolInfoContext();
  const { coinInfoStore } = useCoinInfoContext();
  const [inputValue, setInputValue] = useState('');
  const { isLoading, priceCoinStore } = useCoinPrice();

  return (
    <Modal
      open
      title={fm('select_token')}
      footer={null}
      wrapClassName={styles.inner}
      className={styles.container}
      onCancel={onClose}
    >
      {isLoading && <Loading />}
      {!isLoading && (
        <div>
          <div className={styles.topArea}>
            <div className={styles.chainNameArea}>
              <div className={styles.dot}></div>
              <div className={styles.chainName}>
                {chainNameByChainCodeMap[poolInfo.chainCode]}
              </div>
            </div>
            <Input
              className={styles.input}
              value={inputValue}
              onChange={(v) => {
                setInputValue(v.target.value);
              }}
            />
            <div className={styles.row}>
              <div>{fm('token')}</div>
              <div>{fm('balance')}</div>
            </div>
          </div>
          <div className={styles.content}>
            {poolInfo.whiteList
              .filter((item) => {
                const key = `${poolInfo.chainCode}${item.contractAddress}`;
                return coinInfoStore[key] && priceCoinStore[key];
              })
              .filter((item) => {
                return (
                  coinInfoStore[`${poolInfo.chainCode}${item.contractAddress}`]
                    .symbol || ''
                )
                  .toUpperCase()
                  .includes(inputValue.toUpperCase());
              })
              .map((item, index) => {
                const coininfo =
                  coinInfoStore[`${poolInfo.chainCode}${item.contractAddress}`];
                const priceInfo =
                  priceCoinStore[
                    `${poolInfo.chainCode}${coininfo.contractAddress}`
                  ];

                return (
                  <div
                    className={styles.coinRow}
                    onClick={() => {
                      onSelectCoin(
                        `${poolInfo.chainCode}${coininfo.contractAddress}`,
                        priceInfo.amount
                      );
                      onClose();
                    }}
                    key={index}
                  >
                    <div className={styles.coinBaseInfo}>
                      <img
                        className={styles.coinIcon}
                        src={coininfo.iconNightUrl}
                      />
                      <div>
                        <div className={styles.symbol}>{coininfo.symbol}</div>
                        {!coininfo.contractAddress.includes(ethAddress) && (
                          <div className={styles.contractAddressArea}>
                            <div className={styles.contractAddress}>
                              {shortAddress(coininfo.contractAddress)}
                            </div>
                            <ShareIcon
                              className={styles.share}
                              onClick={(e) => {
                                e.stopPropagation();
                                window?.top?.open(
                                  `${etherscanHostByCode[poolInfo.chainCode]}/token/0x${coininfo.contractAddress}`
                                );
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <div className={styles.amount}>
                        {BigNumber(priceInfo.amount).toFormat()}
                      </div>
                      <div className={styles.value}>
                        {`$${BigNumber(priceInfo.value).toFixed(2)}`}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </Modal>
  );
};
